// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d03ecbe6","455":"c0f07f97","977":"43bb9500"}[chunkId] + ".chunk.js";
};